import HttpClient from "@/utility/http-client";
import { Vue } from 'vue-property-decorator';
import { eventBus } from '@/main';
export default class {
    public state: any;
    public actions: any;
    public mutations: any;
    constructor(endpoint, viewTitle) {
        this.state = {
            loading: false,
            all: {},
            selected: {},
        };
        this.actions = {
            async getList({ commit }, param) {
                commit("setLoading", { loading: true });
                const query = HttpClient.request_payload(param);
                let ret = await HttpClient.instance().get(`/api/${endpoint}/${query}`);
                commit("setList", ret.data);
                commit("setLoading", { loading: false });
            },
            async setDetail({ commit }, { data, id }) {
                if (id > 0) {
                    const ret = await HttpClient.instance().post(`/api/${endpoint}/${id}`, data);
                    eventBus.$emit('REQUEST_REFRESH_DATA');
                    Vue.notify({ group: 'foo', type: 'success', title: 'Thông báo!', text: `Cập nhật ${viewTitle} thành công!` });
                    return ret;
                }
                else {
                    const ret = await HttpClient.instance().put(`/api/${endpoint}/`, data);
                    eventBus.$emit('REQUEST_REFRESH_DATA');
                    Vue.notify({ group: 'foo', type: 'success', title: 'Thông báo!', text: `Tạo mới ${viewTitle} thành công!` });
                    return ret;
                }
            },
            async removeDetail({ commit }, {id, data}) {
                const ret = await HttpClient.instance().delete(`/api/${endpoint}/${id}`, {'data': data});
                eventBus.$emit('REQUEST_REFRESH_DATA');
                Vue.notify({ group: 'foo', type: 'success', title: 'Thông báo!', text: `Xoá ${viewTitle} thành công!` });
                return ret;
            }
        };
        this.mutations = {
            setList(state, data) {
                state.all = data;
            },
            setDetail(state, item) {
                state.selected = item.data ? item.data : item;
            },
            setLoading(state, { loading }) {
                state.loading = loading;
            },
        };
    }
}
